import styled from "@emotion/styled";

import { MonthlyEarnings } from "@/components/pages_public/sales-comp/utils/types";

// Tooltip styling
const TooltipContainer = styled.div`
  padding: 0.75rem;
  width: 400px;
`;

const TooltipTitle = styled.h4`
  margin-bottom: 0.5rem;
  font-weight: 600;
`;

const TooltipGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.25rem;
  font-size: 0.875rem;
`;

const GridItem = styled.div``;

const GridItemRight = styled.div`
  text-align: right;
`;

const GridItemGreen = styled(GridItem)`
  font-weight: 500;
  color: #059669;
`;

const GridItemRightGreen = styled(GridItemRight)`
  font-weight: 500;
  color: #059669;
`;

const GridItemTotal = styled(GridItem)`
  margin-top: 0.25rem;
  border-top: 1px solid #4b5563;
  padding-top: 0.25rem;
  font-weight: 600;
`;

const GridItemRightTotal = styled(GridItemRight)`
  margin-top: 0.25rem;
  border-top: 1px solid #4b5563;
  padding-top: 0.25rem;
  font-weight: 600;
`;

const TooltipFooter = styled.p`
  margin-top: 0.5rem;
  font-size: 0.75rem;
  color: #9ca3af;
`;

interface GuaranteeTooltipProps {
  month: MonthlyEarnings;
}

export function GuaranteeTooltip({ month }: GuaranteeTooltipProps) {
  return (
    <TooltipContainer>
      <TooltipTitle>Commission Guarantee</TooltipTitle>

      <TooltipGrid>
        <GridItem>Earned Commission:</GridItem>
        <GridItemRight>
          ${Math.round(month.earnedCommission).toLocaleString()}
        </GridItemRight>

        <GridItemGreen>+ Guarantee:</GridItemGreen>
        <GridItemRightGreen>
          $
          {Math.round(
            month.protectionAmount - month.earnedCommission,
          ).toLocaleString()}
        </GridItemRightGreen>

        <GridItemTotal>Total Commission:</GridItemTotal>
        <GridItemRightTotal>
          ${Math.round(month.protectionAmount).toLocaleString()}
        </GridItemRightTotal>
      </TooltipGrid>

      <TooltipFooter>
        Month {month.month} guarantee: {month.protectionPercentage}% of target
        commission.
      </TooltipFooter>
    </TooltipContainer>
  );
}
